<script>
import Container from '@/components/Container'
import FavoriteReports from '@/views/FavoriteReports'
import SavedReports from '@/views/SavedReports'
import Reports from '@/views/Reports'
import Dashboards from '@/views/Dashboards'
import AdditionalDashboards from '@/views/AdditionalDashboards'

export default {
  name: 'Home',
  components: {
    AdditionalDashboards,
    Container,
    FavoriteReports,
    SavedReports,
    Reports,
    Dashboards
  }
}
</script>

<template>
  <div class="home">
    <Container>
      <template v-slot:header>Favorite Reports</template>
      <template v-slot:content><FavoriteReports /></template>
    </Container>
    <Container>
      <template v-slot:header>Saved / Shared Reports</template>
      <template v-slot:content><SavedReports /></template>
    </Container>
    <Container>
      <template v-slot:header>Report Categories</template>
      <template v-slot:content><Reports /></template>
    </Container>
    <Container>
      <template v-slot:header>Dashboards</template>
      <template v-slot:content><Dashboards /></template>
    </Container>
    <Container>
      <template v-slot:header>Additional Dashboards</template>
      <template v-slot:content><AdditionalDashboards /></template>
    </Container>
  </div>
</template>

<style>
.home .detailsContainer .containerContent {
  max-height: 300px;
  overflow: auto;
}
</style>
